var _defs, _rect, _rect2, _rect3, _rect4, _polygon, _polygon2, _path, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsA: "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    x: "0px",
    y: "0px",
    width: "62px",
    height: "32px",
    viewBox: "-0.811 -0.716 62 32",
    enableBackground: "new -0.811 -0.716 62 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#007DC5",
    width: 14.177,
    height: 30.839
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.178,
    fill: "#007DC5",
    width: 14.176,
    height: 30.839
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.593,
    fill: "#007DC5",
    width: 14.176,
    height: 30.839
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.77,
    fill: "#007DC5",
    width: 14.176,
    height: 30.839
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "13.015,21.251 8.447,15.162 12.722,9.745 9.039,9.745 5.167,14.765 5.167,9.745 2.04,9.745  2.04,21.251 5.167,21.251 5.167,15.8 9.187,21.251 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "40.58,9.746 40.58,15.366 34.841,9.746 33.052,9.746 33.052,21.251 35.944,21.251 35.944,15.415  41.899,21.251 43.481,21.251 43.481,9.746 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.681,9.414c-3.37,0-6.081,2.443-6.081,6.005s2.711,6.008,6.081,6.008s6.081-2.446,6.081-6.008 S26.051,9.414,22.681,9.414 M25.635,15.418c0,1.954-1.292,3.293-2.954,3.293c-1.665,0-2.954-1.339-2.954-3.293 c0-1.951,1.289-3.293,2.954-3.293C24.343,12.125,25.635,13.467,25.635,15.418"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "52.547,18.64 52.547,16.689 57.625,16.689 57.627,14.226 52.547,14.226 52.547,12.282 58.33,12.282  58.33,9.746 49.456,9.746 49.456,21.252 58.33,21.252 58.33,18.64 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eb04ddb5a61375257b87f77c5fcdf44e.svg";
export { ForwardRef as ReactComponent };